import { render, staticRenderFns } from "./UserSalesChartDonut.vue?vue&type=template&id=723efe6a&"
import script from "./UserSalesChartDonut.vue?vue&type=script&lang=js&"
export * from "./UserSalesChartDonut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports